module.exports = __webpack_public_path__ + "img/vehicles-app.ebc3bb6e.svg";